/**
 * Версии юридических документов (синхронизировано с frontmatter в
 * docs/legal/*.md).
 *
 * Frontend отправляет версии в payload POST /leads. Backend сохраняет в БД
 * для audit trail (152-ФЗ ст. 7 ч. 5 — версия согласия на момент клика).
 *
 * При обновлении md-файла:
 *  1. Обнови `version` в frontmatter md.
 *  2. Обнови соответствующую константу здесь.
 *  3. Обнови backend/src/lib/policy-versions.ts (strict-match validation).
 *  4. (Опционально) если изменилась цель обработки или категория данных —
 *     требуется re-consent для существующих лидов (152-ФЗ ст. 9 ч. 1).
 *     Phase 5+ admin endpoint решит когда это нужно.
 */

export const PD_CONSENT_VERSION = '2.0' as const;
export const PRIVACY_POLICY_VERSION = '2.0' as const;
export const MARKETING_CONSENT_VERSION = '2.0' as const;
